// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d534d44c","491":"0945a191","880":"3c0cbc21"}[chunkId] + ".chunk.js";
};